import axios from '@_system/axios/axios.js'
export default {
	path: '/downloadstatic',
	getexcletask(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getexcletask', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getexcle(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getexcle', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
}